import { Box, CircularProgress, Container, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

let desc = '';

class ConsultaInformesCalificaciones extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            loading: false,
            consulta: false,
            busqueda: {
                anio: '',
                escalafon: '',
            },

            escalafones: [],
            datosConsulta: [],
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
    }
    async componentDidMount(){

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

    }
    render(){
        return (
            <>
                <Container>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    <h3>Informes</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                    {this.state.consulta
                    ?
                        null
                    :
                        <form className='formulario1'  onSubmit={this.manejoEnvioConsulta}>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Año</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Escalafon</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.busqueda.escalafon} onChange={this.manejarCambiosDatos}>
                                            <option value=''></option>
                                            {this.state.escalafones.map((name) =>
                                                <option
                                                key={name.idEscalafon}
                                                value={name.idEscalafon}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    }
                    {this.state.consulta
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Esc</StyledTableCell>
                                        <StyledTableCell>N°</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>C3</StyledTableCell>
                                        <StyledTableCell>C4</StyledTableCell>
                                        <StyledTableCell>C5</StyledTableCell>
                                        <StyledTableCell>C14</StyledTableCell>
                                        <StyledTableCell>C15</StyledTableCell>
                                        <StyledTableCell>C16</StyledTableCell>
                                        <StyledTableCell>C17</StyledTableCell>
                                        <StyledTableCell>C18</StyledTableCell>
                                        <StyledTableCell>C19</StyledTableCell>
                                        <StyledTableCell>C39</StyledTableCell>
                                        <StyledTableCell>C42</StyledTableCell>
                                        <StyledTableCell>C52</StyledTableCell>
                                        <StyledTableCell>C53</StyledTableCell>
                                        <StyledTableCell>C54</StyledTableCell>
                                        <StyledTableCell>Total</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {this.state.datosConsulta.map((name) => (
                                    <StyledTableRow key={name.numeroFuncionario}>
                                        <StyledTableCell>{name.escalafon}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.enfermedad}</StyledTableCell>
                                        <StyledTableCell>{name.enfermedadFamiliar}</StyledTableCell>
                                        <StyledTableCell>{name.estudioExamen}</StyledTableCell>
                                        <StyledTableCell>{name.eCSueldo}</StyledTableCell>
                                        <StyledTableCell>{name.eSSueldo}</StyledTableCell>
                                        <StyledTableCell>{name.faltaCAviso}</StyledTableCell>
                                        <StyledTableCell>{name.faltaSAviso}</StyledTableCell>
                                        <StyledTableCell>{name.suspension}</StyledTableCell>
                                        <StyledTableCell>{name.mesaExamen}</StyledTableCell>
                                        <StyledTableCell>{name.bse}</StyledTableCell>
                                        <StyledTableCell>{name.intFamiliar}</StyledTableCell>
                                        <StyledTableCell>{name.estudioParcial}</StyledTableCell>
                                        <StyledTableCell>{name.cerViaAdm}</StyledTableCell>
                                        <StyledTableCell>{name.subsidioTransitorioBPS}</StyledTableCell>
                                        <StyledTableCell>{name.total}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )
    }
    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        if((this.state.busqueda.anio === '')){
            this.setState({
                errores: 'Debe ingresar el año',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.busqueda]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informesCalificaciones.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                loading: false,
            })
            if(exito[0] === 'ok'){
                this.setState({
                    datosConsulta: exito[1],
                    consulta: true,
                })
            }
        }
    }
}

export default ConsultaInformesCalificaciones